@if (currentPreview() !== null) {
  <div class="space-y-3" data-testid="openalex-preview">
    @if (filterRecap(); as recap) {
      <p class="text-xs text-slate-600 italic" data-testid="preview-filter-recap">{{ recap }}</p>
    }

    @if (currentPreview()!.estimatedCount === 0) {
      <div class="rounded-lg border border-amber-200 bg-amber-50 p-6 text-center">
        <div class="text-3xl mb-2">🔍</div>
        <h3 class="text-sm font-bold text-amber-800 mb-1">No papers found</h3>
        <p class="text-xs text-amber-700">
          Query "<span class="font-semibold">{{ currentQuery() }}</span
          >" matches 0 papers on OpenAlex.
        </p>
        <p class="text-xs text-amber-600 mt-2">
          Try a different search term or adjust the type and venue filters above.
        </p>
      </div>
    } @else {
      <div class="text-sm text-gray-700 p-3">
        Query <span class="font-semibold">{{ currentQuery() }}</span> matches
        <span class="font-semibold" data-testid="preview-total">{{
          currentPreview()!.estimatedCount | numberFormat
        }}</span>
        papers on OpenAlex.
        @if (isTooBroad()) {
          <span class="text-xs text-amber-600 block mt-1">
            Search is too broad. Maximum {{ currentPreview()!.maxAllowed | numberFormat }} papers
            allowed per import. Narrow your search with more specific terms or filters.
          </span>
        }
      </div>
    }

    <div class="flex flex-col-reverse gap-2 sm:flex-row sm:justify-end">
      <button
        type="button"
        (click)="onBack()"
        class="btn-small-secondary"
        data-testid="preview-back"
      >
        Back to query
      </button>
      @if (currentPreview()!.estimatedCount > 0) {
        <button
          type="button"
          (click)="onConfirm()"
          class="btn-primary"
          data-testid="preview-confirm"
          [disabled]="importDisabled()"
        >
          @if (submitting) {
            Starting import…
          } @else {
            Confirm & ingest {{ currentPreview()!.estimatedCount | numberFormat }} papers
          }
        </button>
      }
    </div>
  </div>
}
